module.exports = __webpack_public_path__ + "img/map_pc_1.b3426fd8.png";